import { render, staticRenderFns } from "./couponShareEdit.vue?vue&type=template&id=1e12d2fe&"
import script from "./couponShareEdit.vue?vue&type=script&lang=js&"
export * from "./couponShareEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports